// Config
export const INIT = 'INIT';

// History
export const CREATE_HISTORY_ITEM_SUCCESS = 'CREATE_HISTORY_ITEM_SUCCESS'

export const FETCH_HISTORY_REQUEST = 'FETCH_HISTORY_REQUEST';
export const FETCH_HISTORY_SUCCESS = 'FETCH_HISTORY_SUCCESS';
export const FETCH_HISTORY_FAILURE = 'FETCH_HISTORY_FAILURE';

export const CREATE_ACCOUNT_REQUEST = 'CREATE_ACCOUNT_REQUEST';
export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
export const CREATE_ACCOUNT_FAILURE = 'CREATE_ACCOUNT_FAILURE';

export const UPDATE_ACCOUNT_REQUEST = 'UPDATE_ACCOUNT_REQUEST';
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT_FAILURE = 'UPDATE_ACCOUNT_FAILURE';

export const DELETE_ACCOUNT_REQUEST = 'DELETE_ACCOUNT_REQUEST';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_FAILURE = 'DELETE_ACCOUNT_FAILURE';

export const CLONE_HISTORY_SUCCESS = 'CLONE_HISTORY_SUCCESS'
export const UPDATE_HISTORY_ITEM = 'UPDATE_HISTORY_ITEM'

export const CREATE_GROUP_REQUEST = 'CREATE_GROUP_REQUEST';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';
export const CREATE_GROUP_FAILURE = 'CREATE_GROUP_FAILURE';

export const UPDATE_GROUP_REQUEST = 'UPDATE_GROUP_REQUEST';
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS';
export const UPDATE_GROUP_FAILURE = 'UPDATE_GROUP_FAILURE';

export const DELETE_GROUP_REQUEST = 'DELETE_GROUP_REQUEST';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
export const DELETE_GROUP_FAILURE = 'DELETE_GROUP_FAILURE';

// Navigation
export const SHOW_PREVIOUS_MONTH = 'SHOW_PREVIOUS_MONTH';
export const SHOW_NEXT_MONTH = 'SHOW_NEXT_MONTH';

// UI
export const UI_SHOW_DUMBLEDORE = 'UI_SHOW_DUMBLEDORE';
export const UI_HIDE_DUMBLEDORE = 'UI_HIDE_DUMBLEDORE';
export const UI_TOGGLE_TABS = 'UI_TOGGLE_TABS'



// WEBPACK FOOTER //
// ./src/constants/action-types.js